import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { createApiClient } from './api/client'
import type { ApiClient } from './api/client'
import { useDebounceFn } from '@vueuse/core'

const app = createApp(App)

app.use(stores)
export const api = createApiClient(import.meta.env.VITE_API_BASE_URL)
export const ApiClientKey = Symbol('ApiClient')
app.use(router, api)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

app.provide(ApiClientKey, api)

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: ApiClient
  }
}
app.config.globalProperties.$api = api as unknown as ApiClient
app.mount('#app')
export const debouncedGet = useDebounceFn(async (url, params) => {
  return await api.get(url, params)
}, 400)
export const debouncedPost = useDebounceFn(async (url, params) => {
  return await api.post(url, params)
}, 400)
export const debouncedPut = useDebounceFn(async (url, params) => {
  return await api.put(url, params)
}, 400)
export default app
